exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userlist {\n  vertical-align: inherit;\n  border-color: inherit;\n  color: inherit;\n  background: inherit;\n  padding: 15px,10px; }\n\nthead th {\n  cursor: pointer;\n  margin-right: 15px;\n  margin-left: 15px; }\n  thead th span {\n    visibility: hidden; }\n  thead th.active {\n    color: #000; }\n    thead th.active span {\n      visibility: visible; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/users/users.component.scss
// module id = ../../../../../src/app/users/users.component.scss
// module chunks = main